<template>
  <transition name="menu-slide">
    <div
      v-if="show"
      v-on-clickaway="onClickAway"
      class="options-menu dropdown-pane"
      :class="{ 'dropdown-pane--open': show }"
    >
      <template v-if="!isAccountTypeParent && allowCurrentAccount">
        <availability-status />
        <li class="divider" />
      </template>
      <woot-dropdown-menu>
        <template v-if="!isAccountTypeParent && allowCurrentAccount">
          <woot-dropdown-item class="auto-scroll--toggle">
            <div class="info-wrap">
              <fluent-icon
                v-tooltip.right-start="$t('CONVERSATION.HEADER.TOOLTIP_MESSAGE')"
                icon="info"
                size="14"
                class="info-icon"
              />
              <span class="auto-scroll--text">
                {{ $t('CONVERSATION.HEADER.AUTO_SCROLL') }}
              </span>
            </div>
            <woot-switch
              size="small"
              class="auto-scroll--switch"
              :value="autoScrollEnabled"
              @input="onToggleAutoScroll"
            />
          </woot-dropdown-item>
          <woot-dropdown-divider />
          <woot-dropdown-item class="show-logs--toggle">
            <div class="info-wrap">
              <fluent-icon
                v-tooltip.right-start="$t('SIDEBAR_ITEMS.SHOW_LOG_MESSAGES')"
                icon="info"
                size="14"
                class="info-icon"
              />

              <span class="show-logs--text">
                {{ $t('SIDEBAR_ITEMS.SHOW_LOG_MESSAGES') }}
              </span>
            </div>

            <woot-switch
              size="small"
              class="show-logs--switch"
              :value="currentUserShowLogConversation"
              @input="updateShowLogs"
            />
          </woot-dropdown-item>
          <woot-dropdown-divider />
          <reset-conversations />
          <woot-dropdown-divider />
        </template>
        <woot-dropdown-item v-if="showChangeAccountOption">
          <woot-button
            variant="clear"
            color-scheme="secondary"
            size="small"
            icon="arrow-swap"
            @click="handleToggleAccountsClick"
          >
            {{ $t('SIDEBAR_ITEMS.CHANGE_ACCOUNTS') }}
          </woot-button>
        </woot-dropdown-item>       
        <woot-dropdown-item>
          <router-link
            v-slot="{ href, isActive, navigate }"
            :to="urlProfile"
            custom
          >
            <a
              :href="href"
              class="button small clear secondary"
              :class="{ 'is-active': isActive }"
              @click="e => handleProfileSettingClick(e, navigate)"
            >
              <fluent-icon icon="person" size="14" class="icon icon--font" />
              <span class="button__content">
                {{ $t('SIDEBAR_ITEMS.PROFILE_SETTINGS') }}
              </span>
            </a>
          </router-link>
        </woot-dropdown-item>
        <woot-dropdown-item v-if="canShowDashboardSuperAdmin">
          <a
            href="/super_admin"
            class="button small clear secondary"
            target="_blank"
            rel="noopener nofollow noreferrer"
            @click="$emit('close')"
          >
            <fluent-icon
              icon="content-settings"
              size="14"
              class="icon icon--font"
            />
            <span class="button__content">
              {{ $t('SIDEBAR_ITEMS.SUPER_ADMIN_CONSOLE') }}
            </span>
          </a>
        </woot-dropdown-item>
        <woot-dropdown-item>
          <a
            href="https://sugestoes.phonetrack.app"
            target="_blank"
            class="button small clear secondary"
            @click="$emit('close')"
          >
            <fluent-icon icon="person" size="14" class="icon icon--font" />
            <span class="button__content">
              {{ $t('SIDEBAR_ITEMS.FEEDBACK') }}
            </span>
          </a>
        </woot-dropdown-item>

        <woot-dropdown-item v-if="canShowPortalButton">
          <router-link
            v-slot="{ href, isActive, navigate }"
            :to="`/app/accounts/${accountId}/portals`"
            custom
          >
            <a
              :href="href"
              class="button small clear secondary"
              :class="{ 'is-active': isActive }"
              @click="e => handleProfileSettingClick(e, navigate)"
            >
              <fluent-icon icon="library" size="14" class="icon icon--font" />
              <span class="button__content">
                {{ $t('SIDEBAR_ITEMS.HELP_CENTER') }}
              </span>
            </a>
          </router-link>
        </woot-dropdown-item>

        <woot-dropdown-item v-if="isACustomBrandedInstance">
          <a
            href="https://intelia.notion.site/D-vidas-Frequentes-165f913a01c1806f85b7cccb13d4a0c3"
            target="_blank"
            class="button small clear secondary"
            rel="noopener noreferrer"
            @click="$emit('close')"
          >
            <fluent-icon
              icon="book-open-globe"
              size="14"
              class="icon icon--font"
            />
            <span class="button__content">
              {{ $t('SIDEBAR_ITEMS.DOCS') }}
            </span>
          </a>
        </woot-dropdown-item>

        <woot-dropdown-item v-if="canShowObserverModeButton">
          <woot-button
            variant="clear"
            color-scheme="secondary"
            size="small"
            :icon="isObserverMode ? 'eye-hide' : 'eye-show'"
            @click="openObserverModal"
          >
            {{isObserverMode ? $t('SIDEBAR_ITEMS.DISABLE_OBSERVER_MODE') : $t('SIDEBAR_ITEMS.OBSERVER_MODE') }}
          </woot-button>
        </woot-dropdown-item>
        <ObserverMode ref="observerModeModal" />

        <woot-dropdown-item>
          <woot-button
            variant="clear"
            color-scheme="secondary"
            size="small"
            icon="power"
            @click="logout"
          >
            {{ $t('SIDEBAR_ITEMS.LOGOUT') }}
          </woot-button>
        </woot-dropdown-item>
      </woot-dropdown-menu>
    </div>
  </transition>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import { mapGetters } from 'vuex';
import Auth from '../../../api/auth';
import WootDropdownItem from 'shared/components/ui/dropdown/DropdownItem';
import WootDropdownMenu from 'shared/components/ui/dropdown/DropdownMenu';
import WootDropdownDivider from 'shared/components/ui/dropdown/DropdownDivider';
import AvailabilityStatus from 'dashboard/components/layout/AvailabilityStatus';
import ResetConversations from 'dashboard/components/layout/ResetConversations';
import { frontendURL } from 'dashboard/helper/URLHelper';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import { LocalStorage } from 'shared/helpers/localStorage';
import { BUS_EVENTS } from 'shared/constants/busEvents';
import ObserverMode from '../topbarComponents/ObserverMode';
import agentMixin from 'dashboard/mixins/agentMixin';

export default {
  components: {
    WootDropdownMenu,
    WootDropdownItem,
    AvailabilityStatus,
    WootDropdownDivider,
    ObserverMode,
    ResetConversations,
  },
  mixins: [clickaway, agentMixin],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentUserShowLogConversation: !!LocalStorage.get(
        LOCAL_STORAGE_KEYS.SHOW_LOG_CONVERSATION
      ),
      autoScrollEnabled: true,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      globalConfig: 'globalConfig/get',
      isACustomBrandedInstance: 'globalConfig/isACustomBrandedInstance',
      accountId: 'getCurrentAccountId',
      isObserverMode: 'observerMode/isObserverMode',
      currentRole: 'getCurrentRole',
      isAccountTypeParent: 'isAccountTypeParent',
      allowCurrentAccount: 'allowCurrentAccount'
    }),
    showChangeAccountOption() {
      if (this.globalConfig.createNewAccountFromDashboard) {
        return true;
      }

      const { accounts = [] } = this.currentUser;
      return (accounts.some((account) => account.id != this.accountId));
    },
    feedbackPath() {
      return frontendURL(`accounts/${this.accountId}/feedback`);
    },
    canShowPortalButton() {
      return (
        this.currentUser.type === 'SuperAdmin' ||
        this.currentRole === 'administrator' ||
        (this.agentRules && this.agentRules.portal)
      );
    },
    canShowObserverModeButton() {
      return (
        ['SuperAdmin', 'UserSupport', 'UserManagerAccounts'].includes(this.currentUser.type) ||
        ['administrator', 'supervisor', 'team_supervisor'].includes(this.currentRole)
      );
    },   
    canShowDashboardSuperAdmin(){
      return ['SuperAdmin', 'UserSupport', 'UserManagerAccounts', 'UserPartner'].includes(this.currentUser.type);
    },
    urlProfile(){
      if(this.allowCurrentAccount){
        return `/app/accounts/${this.accountId}/profile/settings`;
      }
      return `/app/user/profile`
    }
  },
  watch: {
    currentUserShowLogConversation(value) {
      LocalStorage.set(LOCAL_STORAGE_KEYS.SHOW_LOG_CONVERSATION, value);
      bus.$emit(BUS_EVENTS.SHOW_LOG_CONVERSATION);
    },
  },
  methods: {
    frontendURL,
    handleProfileSettingClick(e, navigate) {
      this.$emit('close');
      navigate(e);
    },
    handleKeyboardHelpClick() {
      this.$emit('key-shortcut-modal');
      this.$emit('close');
    },
    logout() {
      let promAuthLogout = Auth.logout();
      if (window.inteliaIDURL) {
        promAuthLogout.then(resp => {
          location.href = `${window.inteliaIDURL}/security/logout`;
        });
      }
    },
    onClickAway() {
      if (this.show) this.$emit('close');
    },
    updateShowLogs(showLogConversation) {
      this.currentUserShowLogConversation = showLogConversation;
    },
    openObserverModal() {
      this.$refs.observerModeModal.openPopup();
    },
    onToggleAutoScroll(newValue) {
      this.autoScrollEnabled = newValue;
      window.bus.$emit('toggle-auto-scroll', newValue);
    },
    handleToggleAccountsClick() {
      this.$emit('toggle-accounts');
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.options-menu.dropdown-pane {
  max-height: 85vh; 
  overflow-y: auto;
  right: var(--space-smaller);
  top: var(--space-jumbo);
  min-width: var(--space-giga);
  z-index: var(--z-index-high);
}

.auto-scroll--toggle {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: var(--space-smaller);
  margin: 0;

  .info-wrap {
    display: flex;
    align-items: center;
  }

  .info-icon {
    margin-top: -1px;
  }

  .auto-scroll--switch {
    margin: -1px var(--space-micro) 0;
  }

  .auto-scroll--text {
    margin: 0 var(--space-smaller);
    font-size: var(--font-size-mini);
    font-weight: var(--font-weight-medium);
    color: var(--s-700);
  }
}

.show-logs--toggle {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: var(--space-smaller);
  margin: 0;
  .info-wrap {
    display: flex;
    align-items: center;
  }
  .info-icon {
    margin-top: -1px;
  }
  .show-logs--switch {
    margin: -1px var(--space-micro) 0;
  }

  .show-logs--text {
    margin: 0 var(--space-smaller);
    font-size: var(--font-size-mini);
    font-weight: var(--font-weight-medium);
    color: var(--s-700);
  }
}
</style>
